class LocalStorage {
    constructor() {
        this.localStorageSupported = typeof window['localStorage'] != "undefined" && window['localStorage'] != null;
    }

    get(key) {
        if (this.localStorageSupported) {
            return window.localStorage.getItem(key);
        }
    }

    set(key, item) {
        if (this.localStorageSupported) {
            window.localStorage.setItem(key, item);
        }
    }
}

const ls = new LocalStorage();

export default ls;